module.exports = __webpack_public_path__ + "img/wallpaper-chat-with-the-planet.c9580fb3.png";